<template>
  <div class="main">
    <div class="opt">
      <div class="title">{{ $fanyi('订单进程') }}</div>
      <div class="pageJumpListContainer">
        <div class="pageJumpContainer" @click="
          $fun.toPage('/user/order?status=temporary'),
          update()
          ">

          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.order_tamp" :endVal="newCountNumInfo.order_tamp" :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('临时保存的订单') }}</div>

          </div>
          <div class="icon temporary">
            <img src="../../../../assets/newassets/userindex/icon1.svg" alt="" />
          </div>
        </div>
        <div class="pageJumpContainer" @click="
          $fun.toPage('/user/order?status=obligation'),
          update()
          ">

          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.order_un_delivery" :endVal="newCountNumInfo.order_un_delivery"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('待付款的订单') }}</div>

          </div>
          <div class="icon pending">
            <img src="../../../../assets/newassets/userindex/icon2.svg" alt="" />
          </div>
        </div>
        <div class="pageJumpContainer" @click="
          $fun.toPage('/user/order?status=received'),
          update()
          ">

          <!--          待收货订单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.order_purchase_uncomplete"
                :endVal="newCountNumInfo.order_purchase_uncomplete" :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('等待工厂发货的订单') }}</div>

          </div>
          <div class="icon RECEPCIONPENDIENTE">
            <img src="../../../../assets/newassets/userindex/icon3.svg" alt="" />
          </div>
        </div>
        <div class="pageJumpContainer" style="margin: 0 0 20px 0;" @click="
          $fun.toPage('/user/order?status=inspection'),

          update()
          ">

          <!--          检品中订单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.order_inspecting" :endVal="newCountNumInfo.order_inspecting"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('检品') }}</div>

          </div>
          <div class="icon CONTROLDECALIDAD">
            <img src="../../../../assets/newassets/userindex/icon4.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="pageJumpListContainer" @click="
        $fun.toPage('/user/order?status=warehouse'),

        update()
        ">
        <div class="pageJumpContainer" style="margin: 0 20px 20px 0;">

          <!--          在RAKUMART仓库中订单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.order_up_complete" :endVal="newCountNumInfo.order_up_complete"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('货物到达Rakumart中国仓库') }}</div>

          </div>
          <div class="icon WAREHOUSE">
            <img src="../../../../assets/newassets/userindex/icon5.svg" alt="" />
          </div>
        </div>

        <div class="pageJumpContainer" @click.stop="
          $fun.toPage('/user/packinglist?status=internationalFreightToBeQuotedDeliverySheet'),

          update()
          ">

          <!--          国际运费待报价配送单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.porder_wait_offer" :endVal="newCountNumInfo.porder_wait_offer"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('国际运费报价') }}</div>

          </div>
          <div class="icon FLETEPENDIENTECOTIZACION">
            <img src="../../../../assets/newassets/userindex/icon6.svg" alt="" />
          </div>
        </div>

        <div class="pageJumpContainer" @click.stop="
          $fun.toPage('/user/packinglist?status=Tobepaid')">

          <!--          国际运费待支付配送单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.porder_wait_pay" :endVal="newCountNumInfo.porder_wait_pay"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('国际运费待支付') }}</div>

          </div>
          <div class="icon ENVIOPENDIENTEDEPAGO">
            <img src="../../../../assets/newassets/userindex/icon7.svg" alt="" />
          </div>
        </div>
        <div class="pageJumpContainer" style="margin: 0 0 20px 0;" @click.stop="
          $fun.toPage('/user/packinglist?status=orderForDelivery'),
          update()
          ">

          <!--          待发货配送单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.porder_pay_un_delivery" :endVal="newCountNumInfo.porder_pay_un_delivery"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('待装仓') }}</div>

          </div>
          <div class="icon ESPERADERECOGIDA">
            <img src="../../../../assets/newassets/userindex/icon8.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="pageJumpListContainer" @click="
        $fun.toPage('/user/packinglist?status=deliveryInTransit'),
        update()
        ">
        <div class="pageJumpContainer">

          <!--          运输中配送单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.porder_in_sea" :endVal="newCountNumInfo.porder_in_sea"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('中国发往乌克兰的订单') }}</div>

          </div>
          <div class="icon ENTRANSITOHACIAESPAÑA">
            <img src="../../../../assets/newassets/userindex/icon9.svg" alt="" />
          </div>
        </div>

        <div class="pageJumpContainer" @click.stop="
          $fun.toPage('/user/packinglist?status=Usdeliveryunderway'), update()
          ">

          <!--          西班牙派送配送单-->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.porder_foreign_express" :endVal="newCountNumInfo.porder_foreign_express"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('乌克兰派送中') }}</div>

          </div>
          <div class="icon ENVIONACIONALENCURSO">
            <img src="../../../../assets/newassets/userindex/icon10.svg" alt="" />
          </div>
        </div>
        <div class="pageJumpContainer" style="margin: 0 0 20px 0;" @click.stop="
          $fun.toPage('/user/packinglist?status=Signedandreceived'), update()">

          <!--已签收配送单 -->
          <div class="right">
            <div class="number">
              <countTo :startVal="countNumInfo.porder_receive" :endVal="newCountNumInfo.porder_receive"
                :duration="3000" />
            </div>
            <div class="text">{{ $fanyi('已收货') }}</div>

          </div>
          <div class="icon ENTREGADO">
            <img src="../../../../assets/newassets/userindex/icon11.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
export default {
  components: {
    countTo,
  },
  data() {
    return {
      shopLoading: true,
      countNumInfo: {
        order_tamp: 0, //临时订单
        order_un_delivery: 0, //待处理订单(未完全发出)
        order_purchase_uncomplete: 0, //购买中
        order_up_complete: 0, //货物上架完成 (未完全发出)
        order_inspecting: 0, //检品中
        porder_wait_offer: 0, //配送单待报价
        porder_wait_pay: 0, //配送单待支付
        porder_pay_un_delivery: 0, //已支付待发货
        porder_in_sea: 0, //国际运输中
        porder_cleared: 0, //已通过
        porder_foreign_express: 0, //外国运输中
        porder_receive: 0, //已签收
      },
      newCountNumInfo: {
        order_tamp: 0, //临时订单
        order_un_delivery: 0, //待处理订单(未完全发出)
        order_purchase_uncomplete: 0, //购买中
        order_up_complete: 0, //货物上架完成 (未完全发出)
        order_inspecting: 0, //检品中
        porder_wait_offer: 0, //配送单待报价
        porder_wait_pay: 0, //配送单待支付
        porder_pay_un_delivery: 0, //已支付待发货
        porder_in_sea: 0, //国际运输中
        porder_cleared: 0, //已通过
        porder_foreign_express: 0, //外国运输中
        porder_receive: 0, //已签收
      },
    }
  },

  created() {
    this.getContentCountNum()
  },
  methods: {
    // 获取个人中心看板统计底部统计数据
    getContentCountNum() {
      this.$api
        .contentCountNum()
        .then((res) => {
          this.newCountNumInfo = res.data
        })
        .catch(() => { })
    },
    update() {
      this.$emit('signStatusVerdict', 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.main {
  .opt {
    width: 100%;
    margin-bottom: 20px;

    .title {
      font-weight: normal;
      font-size: 18px;
      color: #121212;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .pageJumpListContainer {
      display: flex;
      align-items: center;

      .pageJumpContainer {
        width: 250px;
        height: 150px;
        background: #FFFFFF;
        border-radius: 20px;
        margin: 0 20px 20px 0;
        padding: 20px;
        display: flex;

        cursor: pointer;
        position: relative;

        .icon {
          position: absolute;
          right: 20px;
          width: 50px;
          top: 20px;
          height: 50px;
          background: #FAE9E8;
          border-radius: 25px;

          display: flex;
          align-items: center;
          justify-content: center;


        }

        .right {
          margin-top: 10px;

          .number {
            color: #2f2f2f;
            font-weight: 600;
            height: 30px;
            font-weight: bold;
            font-size: 24px;
            color: #121212;
            display: flex;
            align-items: center;
            padding-right: 62px;
            font-size: 24px;
            margin-bottom: 20px;
          }

          .text {
            font-weight: 400;
            font-size: 14px;
            color: #121212;
            line-height: 16px;
          }
        }
      }
    }
  }
}
</style>
